import { getMetricQuery } from '@gonfalon/rest-api/queries/metrics';
import { useProjectKey } from '@gonfalon/router/useProjectKey';
import { useQueries } from '@tanstack/react-query';

export function useMetricsByKeys(keys: string[], options?: { staleTime?: number }) {
  const projectKey = useProjectKey();

  const metricsQueries = useQueries({
    queries: keys.map((metricKey) => ({
      ...getMetricQuery({
        projectKey,
        metricKey,
        query: {
          expand: ['experiments', 'eventSources', 'guardedRolloutCount', 'releasePolicyCount'] as Array<
            'experiments' | 'eventSources' | 'guardedRolloutCount' | 'releasePolicyCount'
          >,
        },
      }),
      ...(options?.staleTime !== undefined && { staleTime: options.staleTime }),
    })),
  });
  const isPending = metricsQueries.some((query) => query.isPending);
  const isFetching = metricsQueries.some((query) => query.isFetching);
  const isError = metricsQueries.some((query) => query.isError);

  // return an empty list until all metrics are fetched
  if (isPending) {
    return {
      metrics: undefined,
      isPending,
      isFetching,
      isError,
    };
  }

  const metrics = metricsQueries
    .map((query) => query.data)
    .filter((metric): metric is Exclude<typeof metric, undefined> => typeof metric !== 'undefined');

  return {
    metrics,
    isPending,
    isFetching,
    isError,
  };
}
